// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WjTh1pJ3vxw6inoZ0Gad {
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
  width: fit-content;
  padding: 8px 10px;
  border-radius: 12px;
  border: 1px solid transparent;
  outline: unset;
  background-color: transparent;
  font-size: 16px !important;
  font-weight: 500;
  transition: all 0.3s;
}
.WjTh1pJ3vxw6inoZ0Gad svg path {
  transition: all 0.3s;
}
.WjTh1pJ3vxw6inoZ0Gad:focus {
  outline: none;
}
.WjTh1pJ3vxw6inoZ0Gad:hover {
  cursor: pointer;
}
.WjTh1pJ3vxw6inoZ0Gad:disabled {
  cursor: not-allowed;
}

.pimpozROv1Y6Bft_d1Qw {
  background-color: #774dee;
  color: #fff;
}
.pimpozROv1Y6Bft_d1Qw:hover {
  background-color: #6439df;
  transition: all 0.3s;
}
.pimpozROv1Y6Bft_d1Qw:active {
  background-color: #5b37c0;
  color: #b6b6b6;
  transition: all 0.3s;
}
.pimpozROv1Y6Bft_d1Qw:disabled {
  background-color: rgba(237, 235, 239, 0.5);
  color: rgba(50, 50, 50, 0.4);
  transition: all 0.3s;
}
.pimpozROv1Y6Bft_d1Qw:focus {
  border: 1px solid #fff;
}

.Mh1N_tZ768LOk80iKQzu {
  background-color: transparent;
  color: #774dee;
  border-color: #774dee;
}
.Mh1N_tZ768LOk80iKQzu:hover {
  color: #6439df;
  border-color: #6439df;
  transition: all 0.3s;
}
.Mh1N_tZ768LOk80iKQzu:active {
  color: #5b37c0;
  border-color: #5b37c0;
  transition: all 0.3s;
}
.Mh1N_tZ768LOk80iKQzu:focus {
  border: 1px solid #fff;
}
.Mh1N_tZ768LOk80iKQzu:disabled {
  color: rgba(237, 235, 239, 0.5);
  border-color: rgba(237, 235, 239, 0.5);
  transition: all 0.3s;
}

.UWLO1xEVbXygTpN3QGQa {
  color: #774dee;
}
.UWLO1xEVbXygTpN3QGQa:hover {
  color: #6439df;
  transition: all 0.3s;
}
.UWLO1xEVbXygTpN3QGQa:active {
  color: #5b37c0;
  transition: all 0.3s;
}
.UWLO1xEVbXygTpN3QGQa:disabled {
  color: rgba(237, 235, 239, 0.5);
  transition: all 0.3s;
}

.O9jNHRkcraX5SlkxuMuL {
  background-color: rgba(50, 50, 50, 0.8);
  color: #fff;
}
.O9jNHRkcraX5SlkxuMuL:hover {
  background-color: #262626;
  transition: all 0.3s;
}
.O9jNHRkcraX5SlkxuMuL:active {
  background-color: #1e1e1e;
  color: #b6b6b6;
  transition: all 0.3s;
}
.O9jNHRkcraX5SlkxuMuL:disabled {
  background-color: rgba(50, 50, 50, 0.6);
  color: #636363;
  transition: all 0.3s;
}

.JXi49DmPFOqiAXhtf68i {
  background-color: #ededed;
  color: #3d3d3d;
  border-radius: 18px;
  box-shadow: 0px 7px 3px 0px rgba(0, 0, 0, 0.32);
}
.JXi49DmPFOqiAXhtf68i:active {
  border: 1px solid #fff;
  background-color: #dbdbdb;
}
.JXi49DmPFOqiAXhtf68i:focus {
  border: 1px solid #fff;
}
.JXi49DmPFOqiAXhtf68i:hover {
  background-color: #fff;
  transition: all 0.3s;
}
.JXi49DmPFOqiAXhtf68i:disabled {
  background-color: #636363;
  color: rgba(50, 50, 50, 0.4);
  transition: all 0.3s;
}

.QIW1PAeBa1KRBfcujqao {
  background-color: rgba(50, 50, 50, 0.8);
  color: #dbdbdb;
  border-radius: 10px;
}
.QIW1PAeBa1KRBfcujqao:active {
  background-color: #282828;
}
.QIW1PAeBa1KRBfcujqao:focus {
  border: 1px solid #fff;
  background-color: #2d2d2d;
}
.QIW1PAeBa1KRBfcujqao:hover {
  background-color: #2d2d2d;
  transition: all 0.3s;
}
.QIW1PAeBa1KRBfcujqao:disabled {
  color: #474747;
  transition: all 0.3s;
}

._F25lLNvImOK06RvKI1N {
  background-color: rgba(50, 50, 50, 0.6);
  color: #dbdbdb;
  border-radius: 10px;
  padding: 4px 4px !important;
}
._F25lLNvImOK06RvKI1N:active {
  background-color: #282828;
}
._F25lLNvImOK06RvKI1N:focus {
  border: 1px solid #fff;
  background-color: #2d2d2d;
}
._F25lLNvImOK06RvKI1N:hover {
  background-color: #2d2d2d;
  transition: all 0.3s;
}
._F25lLNvImOK06RvKI1N:disabled {
  color: #474747;
  transition: all 0.3s;
}

.lniDG2VhdL4jl6ppzAKq {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 24px;
}

.wiZ4h01Qbv1hN3vEAS2d {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  background-color: #774dee;
  width: 0;
}
.wiZ4h01Qbv1hN3vEAS2d.Ng5UwA0idAmY89_MDD3J {
  animation: eirGRk5xbxhf3MzDjXzf var(--press-duration, 2000ms) linear forwards;
}

@keyframes eirGRk5xbxhf3MzDjXzf {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/Button/Button.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,6BAAA;EACA,0BAAA;EACA,gBAAA;EACA,oBAAA;AAAF;AAEE;EACE,oBAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAKE;EACE,mBAAA;AAHJ;;AAOA;EACE,yBC/BO;EDgCP,WClBM;ADcR;AAME;EACE,yBClCS;EDmCT,oBAAA;AAJJ;AAOE;EACE,yBCtCS;EDuCT,cCtBY;EDuBZ,oBAAA;AALJ;AAQE;EACE,0CAAA;EACA,4BAAA;EACA,oBAAA;AANJ;AASE;EACE,sBAAA;AAPJ;;AAWA;EACE,6BAAA;EACA,cC1DO;ED2DP,qBC3DO;ADmDT;AAUE;EACE,cC7DS;ED8DT,qBC9DS;ED+DT,oBAAA;AARJ;AAWE;EACE,cClES;EDmET,qBCnES;EDoET,oBAAA;AATJ;AAYE;EACE,sBAAA;AAVJ;AAaE;EACE,+BAAA;EACA,sCAAA;EACA,oBAAA;AAXJ;;AAeA;EACE,cCrFO;ADyET;AAcE;EACE,cCvFS;EDwFT,oBAAA;AAZJ;AAeE;EACE,cC3FS;ED4FT,oBAAA;AAbJ;AAgBE;EACE,+BAAA;EACA,oBAAA;AAdJ;;AAkBA;EACE,uCAAA;EACA,WC3FM;AD4ER;AAiBE;EACE,yBCnEQ;EDoER,oBAAA;AAfJ;AAkBE;EACE,yBCrEQ;EDsER,cC/FY;EDgGZ,oBAAA;AAhBJ;AAmBE;EACE,uCAAA;EACA,cCxFO;EDyFP,oBAAA;AAjBJ;;AAqBA;EACE,yBCxGc;EDyGd,cClGS;EDmGT,mBAAA;EACA,+CAAA;AAlBF;AAoBE;EACE,sBAAA;EACA,yBChHY;AD8FhB;AAqBE;EACE,sBAAA;AAnBJ;AAsBE;EACE,sBC/HI;EDgIJ,oBAAA;AApBJ;AAuBE;EACE,yBClHO;EDmHP,4BAAA;EACA,oBAAA;AArBJ;;AAyBA;EACE,uCAAA;EACA,cAAA;EACA,mBAAA;AAtBF;AAwBE;EACE,yBAAA;AAtBJ;AAyBE;EACE,sBAAA;EACA,yBAAA;AAvBJ;AA0BE;EACE,yBAAA;EACA,oBAAA;AAxBJ;AA2BE;EACE,cAAA;EACA,oBAAA;AAzBJ;;AA6BA;EACE,uCAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;AA1BF;AA4BE;EACE,yBAAA;AA1BJ;AA6BE;EACE,sBAAA;EACA,yBAAA;AA3BJ;AA8BE;EACE,yBAAA;EACA,oBAAA;AA5BJ;AA+BE;EACE,cAAA;EACA,oBAAA;AA7BJ;;AAiCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,yBCxNO;EDyNP,QAAA;AA9BF;AAgCE;EACE,6EAAA;AA9BJ;;AAkCA;EACE;IACE,QAAA;EA/BF;EAiCA;IACE,WAAA;EA/BF;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonWrapper": `WjTh1pJ3vxw6inoZ0Gad`,
	"filledButton": `pimpozROv1Y6Bft_d1Qw`,
	"outlinedButton": `Mh1N_tZ768LOk80iKQzu`,
	"ghostButton": `UWLO1xEVbXygTpN3QGQa`,
	"toolButton": `O9jNHRkcraX5SlkxuMuL`,
	"whiteButton": `JXi49DmPFOqiAXhtf68i`,
	"customButton": `QIW1PAeBa1KRBfcujqao`,
	"saveButton": `_F25lLNvImOK06RvKI1N`,
	"icon": `lniDG2VhdL4jl6ppzAKq`,
	"pressProgress": `wiZ4h01Qbv1hN3vEAS2d`,
	"pressing": `Ng5UwA0idAmY89_MDD3J`,
	"progress": `eirGRk5xbxhf3MzDjXzf`
};
export default ___CSS_LOADER_EXPORT___;
